/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */
import { formatDate } from "@vueuse/core";
import i18n from "../i18n/index.js";

const t = i18n.global.t;

/**
 * The FormatService class provides utility methods for formatting dates, date-times,
 * and boolean values into user-friendly string representations.
 */
class FormatService {
  toLocaleDateString(datestr) {
    if (!datestr) {
      return "";
    }
    let date = new Date(datestr);
    return new Intl.DateTimeFormat("fr-FR").format(date);
  }
  formatDate(value) {
    if (!value) {
      return "";
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return "";
    }
    return formatDate(date, "ddd D MMM YYYY");
  }
  formatDateTime(value) {
    if (!value) {
      return "";
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
      return "";
    }
    return formatDate(date, "ddd D MMM YYYY - HH:mm:ss");
  }
  formatBool(value) {
    if (value === true) {
      return t("yes");
    }
    if (value === false) {
      return t("no");
    }
  }
}
export default new FormatService();
